module.exports = __webpack_public_path__ + "static/media/HB_bibimbap_square_Forweb.d21900be.jpg";